import React from 'react';
import { UpdateCustomBitlySettingsInput } from '../../../../models/graphql';
import { GetBitlyAccounts_workspace_socialProfiles } from '../../../../models/legacy-graphql';
import { SelectItem } from '../../../../components/forms/Select/Select.view';
import { SocialProfile } from '../../../../components/socialProfiles/SocialProfile';
import { Loader } from '../../../../components/containers/Loader';
import { Select } from '../../../../components/forms/Select';
import classNames from 'classnames';
import classes from '../LinkTracking.module.scss';
import { profilesHelpers } from '../../Profiles/Profiles.helpers';
import { useForm } from 'react-hook-form';
import { FormOptions } from '../../../../constants/form';
import { FormElementAction } from '../../../../models/basic-objects';

export type LinkTrackingSocialProfilesListProps = {
  loading: boolean;
  socialProfiles: GetBitlyAccounts_workspace_socialProfiles[];
  getBitlyDomainListSelectItems: (profileId: string) => Array<SelectItem>;
  getCustomBitlySettingsValueInput: (profileId: string) => UpdateCustomBitlySettingsInput;
  customBitlyDomainSelectHandler: FormElementAction;
};

export const LinkTrackingSocialProfilesListView = (props: LinkTrackingSocialProfilesListProps): JSX.Element => {
  const useFormInstance = useForm({
    ...FormOptions
  });

  return (
    <>
      {props.socialProfiles.map((profile, index) => {
        const isFirstListItem = index === 0;
        const isLastListItem = index !== props.socialProfiles.length - 1;
        const domainList = props.getBitlyDomainListSelectItems(profile.id);
        const selectedValue = props.getCustomBitlySettingsValueInput(profile.id);
        const socialProfileWrapperClasses = classNames('cell small-12 large-6', [classes.Label]);
        const wrapperClass = classNames(
          'grid-x grid-margin-x',
          isLastListItem ? 'margin-bottom-small-16' : 'margin-bottom-small-32',
          {
            'margin-top-small-24 margin-top-large-16': isFirstListItem
          }
        );

        return (
          <div key={`profile-key-${index}`} className={wrapperClass}>
            <div className={socialProfileWrapperClasses}>
              <SocialProfile
                size={'medium'}
                socialProfile={profilesHelpers.remapSocialProfile(profile, false, false, false)}
                label={true}
                sublabel={false}
                image={profile.photoUrl}
                disconnected={!profile.connected}
              />
            </div>
            <div className={'cell small-12 large-6 margin-top-small-16 margin-top-large-0'}>
              {props.loading ? (
                <Loader variation={'dark'} size={'small'} />
              ) : (
                <Select
                  items={domainList}
                  name={`customLinkTracking.${profile.id}`}
                  rules={{}}
                  size={'large'}
                  useFormInstance={useFormInstance}
                  action={(value, complete) => props.customBitlyDomainSelectHandler(value, complete)}
                  selectedValue={JSON.stringify(selectedValue)}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};
